export const DEFAULT_WALLET_PAYMENT_LABEL = "Get your color";

const PAYWALL_ROUTES = [
  {
    prefix: "/makeup-3month-29-upsell-v2",
    paywall: "makeup-3month-29-upsell-v2",
    paymentLabel: "Makeup results",
  },
  {
    prefix: "/glasses-3month-29-upsell-v2",
    paywall: "glasses-3month-29-upsell-v2",
    paymentLabel: "Glasses results",
  },
  {
    prefix: "/sunglasses-3month-29-upsell-v2",
    paywall: "sunglasses-3month-29-upsell-v2",
    paymentLabel: "Glasses results",
  },
  {
    prefix: "/colortype-3month-29-upsell-v2",
    paywall: "colortype-3month-29-upsell",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/colortype-3month-29-upsell",
    paywall: "colortype-3month-29-upsell",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/colortype-3month-29",
    paywall: "colortype-3month-29",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/colortype-1month-29",
    paywall: "colortype-1month-29",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/haircolor-recomend-3month-29",
    paywall: "haircolor-recomend-3month-29",
    paymentLabel: "Hair color results",
  },
  {
    prefix: "/haircolor-3month-29",
    paywall: "haircolor-3month-29",
    paymentLabel: "Hair color results",
  },
  {
    prefix: "/hairstyle-3month-29-man",
    paywall: "hairstyle-3month-29-man",
    paymentLabel: "Hairstyle results",
  },
  {
    prefix: "/hairstyle-3month-29-woman",
    paywall: "hairstyle-3month-29-woman",
    paymentLabel: "Hairstyle results",
  },
  {
    prefix: "/bodytype-3month-29-woman",
    paywall: "bodytype-3month-29-woman",
    paymentLabel: "Body type results",
  },
  {
    prefix: "/wedding-guest-3month-29-woman",
    paywall: "wedding-guest-3month-29-woman",
    paymentLabel: "Body type results",
  },
  {
    prefix: "/faceshape-3month-29",
    paywall: "faceshape-3month-29",
    paymentLabel: "Face shape results",
  },
  {
    prefix: "/faceshape_3month_29",
    paywall: "faceshape-3month-29",
    paymentLabel: "Face shape results",
  },
  {
    prefix: "/v1_3months_upsell",
    paywall: "colortype-3month-29-upsell",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/hairstyle-man",
    paywall: "hairstyle-3month-29-man",
    paymentLabel: "Hairstyle results",
  },
  {
    prefix: "/hairstyle",
    paywall: "hairstyle-3month-29-woman",
    paymentLabel: "Hairstyle results",
  },
  {
    prefix: "/hair",
    paywall: "haircolor-3month-29",
    paymentLabel: "Hair color results",
  },
  {
    prefix: "/month",
    paywall: "colortype-1month-29",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/v1",
    paywall: "colortype-3month-29",
    paymentLabel: "Color analysis",
  },
  {
    prefix: "/v2",
    paywall: "v2",
    paymentLabel: "Color analysis",
  },
];

export const getPaywallContext = (pathname = "") => {
  if (pathname === "/") {
    return {
      paywall: "main",
      paymentLabel: "Color analysis",
    };
  }

  const route = PAYWALL_ROUTES.find((item) => pathname.startsWith(item.prefix));

  return {
    paywall: route?.paywall,
    paymentLabel: route?.paymentLabel,
  };
};

export const getWalletPaymentLabel = (pathname = "") =>
  getPaywallContext(pathname).paymentLabel || DEFAULT_WALLET_PAYMENT_LABEL;
